import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="bg-brand-darkBlue py-16 md:py-20 px-5 md:px-10">
        <div className="max-w-7xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-brand-red mb-3">Services We Offer</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">Expert In-Home Health Staffing</h1>
          <p className="mt-5 text-lg text-white/80 max-w-2xl">
            Providing exceptional, trustworthy in-home healthcare staffing solutions tailored to meet your specific needs across the United States.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 px-5 md:px-10">
        <div className="max-w-7xl mx-auto space-y-16">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Heart;
            const reverse = i % 2 === 1;
            return (
              <Reveal key={s.slug}>
                <div className="grid lg:grid-cols-2 gap-10 items-center" data-testid={`service-detail-${s.slug}`}>
                  <div className={`overflow-hidden rounded-3xl shadow-xl ${reverse ? "lg:order-2" : ""}`}>
                    <motion.img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-[360px] object-cover"
                      whileHover={{ scale: 1.06 }}
                      transition={{ duration: 0.6 }}
                    />
                  </div>
                  <div className={reverse ? "lg:order-1" : ""}>
                    <div className="w-14 h-14 rounded-2xl bg-brand-lightBlue flex items-center justify-center mb-5">
                      <Icon className="w-8 h-8 text-brand-darkBlue" />
                    </div>
                    <h2 className="text-3xl font-bold text-brand-darkBlue">{s.title}</h2>
                    <p className="mt-4 text-lg text-gray-800 leading-relaxed">{s.description}</p>
                    <Link to="/contact#consultation" data-testid={`service-book-${s.slug}`} className="mt-6 inline-flex items-center gap-2 text-brand-red font-semibold text-lg hover:gap-3 transition-all">
                      Book this service <ArrowRight className="w-5 h-5" />
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-brand-lightBlue py-16 px-5 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-brand-darkBlue">Not sure which service is right for you?</h2>
          <p className="mt-4 text-lg text-gray-800">Our licensed clinical professionals will help you build a personalized care plan.</p>
          <Link to="/contact#consultation" data-testid="services-cta-btn" className="mt-8 inline-flex bg-brand-red text-white font-semibold py-4 px-8 rounded-full hover:bg-brand-redDark transition-colors">
            Book a Free Consultation
          </Link>
        </div>
      </section>
    </div>
  );
}
